import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from 'components/Investors/List';

export default class Investors extends React.Component {
  render = () => {
    const { match } = this.props;
    return (
      <div>
        <Switch>
          <Route exact path='/investors' component={List}/>
        </Switch>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Investors/index.js